module.exports = __webpack_public_path__ + "static/media/fruits_35.15189fa2.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_35.csv
// module id = 701
// module chunks = 0